import { render, staticRenderFns } from "./IF-ClearanceDep.vue?vue&type=template&id=5af87c58&scoped=true&"
import script from "./IF-ClearanceDep.vue?vue&type=script&lang=js&"
export * from "./IF-ClearanceDep.vue?vue&type=script&lang=js&"
import style0 from "./IF-ClearanceDep.vue?vue&type=style&index=0&id=5af87c58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af87c58",
  null
  
)

export default component.exports